"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.tableCell = void 0;

var _util = require("../../../util");

const tableCell = ({
  cssProps,
  theme
}) => {
  const {
    align = 'left',
    headerCell = false,
    padding = 0,
    stickyHeader,
    variant = 'primary',
    verticalAlign
  } = cssProps;
  const themeVariant = theme.tables[variant];
  return { ...(stickyHeader ? {
      position: 'sticky',
      top: 0,
      backgroundColor: (0, _util.color)(theme, themeVariant.headerBg),
      boxShadow: (0, _util.boxShadow)(theme, themeVariant.headerCellBoxShadow)
    } : undefined),
    display: 'table-cell',
    height: headerCell ? themeVariant.headerHeight : themeVariant.cellHeight,
    minWidth: themeVariant.minWidth,
    padding: (0, _util.spacing)(theme, padding),
    textAlign: align,
    verticalAlign
  };
};

exports.tableCell = tableCell;
//# sourceMappingURL=TableCell.style.js.map